
export const userInviteConstants = {
    GET_USER_INVITE_REQUEST: 'GET_USER_INVITE_REQUEST',
    GET_USER_INVITE_SUCCESS: 'GET_USER_INVITE_SUCCESS',
    GET_USER_INVITE_FAILURE: 'GET_USER_INVITE_FAILURE',

    LIST_USER_INVITE_REQUEST: 'LIST_USER_INVITE_REQUEST',
    LIST_USER_INVITE_SUCCESS: 'LIST_USER_INVITE_SUCCESS',
    LIST_USER_INVITE_FAILURE: 'LIST_USER_INVITE_FAILURE',

    ACCEPT_USER_INVITE_REQUEST: 'ACCEPT_USER_INVITE_REQUEST',
    ACCEPT_USER_INVITE_SUCCESS: 'ACCEPT_USER_INVITE_SUCCESS',
    ACCEPT_USER_INVITE_FAILURE: 'ACCEPT_USER_INVITE_FAILURE',

    REVOKE_USER_INVITE_REQUEST: 'REVOKE_USER_INVITE_REQUEST',
    REVOKE_USER_INVITE_SUCCESS: 'REVOKE_USER_INVITE_SUCCESS',
    REVOKE_USER_INVITE_FAILURE: 'REVOKE_USER_INVITE_FAILURE',

    UNREVOKE_USER_INVITE_REQUEST: 'UNREVOKE_USER_INVITE_REQUEST',
    UNREVOKE_USER_INVITE_SUCCESS: 'UNREVOKE_USER_INVITE_SUCCESS',
    UNREVOKE_USER_INVITE_FAILURE: 'UNREVOKE_USER_INVITE_FAILURE',

    RESEND_USER_INVITE_REQUEST: 'RESEND_USER_INVITE_REQUEST',
    RESEND_USER_INVITE_SUCCESS: 'RESEND_USER_INVITE_SUCCESS',
    RESEND_USER_INVITE_FAILURE: 'RESEND_USER_INVITE_FAILURE',

    CREATE_USER_INVITE_REQUEST: 'CREATE_USER_INVITE_REQUEST',
    CREATE_USER_INVITE_SUCCESS: 'CREATE_USER_INVITE_SUCCESS',
    CREATE_USER_INVITE_FAILURE: 'CREATE_USER_INVITE_FAILURE',

    PASSWORD_STATUS_REQUEST: 'PASSWORD_STATUS_REQUEST',
    PASSWORD_STATUS_SUCCESS: 'PASSWORD_STATUS_SUCCESS',
    PASSWORD_STATUS_FAILURE: 'PASSWORD_STATUS_FAILURE',

    CREATE_PASSWORD_REQUEST: 'CREATE_PASSWORD_REQUEST',
    CREATE_PASSWORD_SUCCESS: 'CREATE_PASSWORD_SUCCESS',
    CREATE_PASSWORD_FAILURE: 'CREATE_PASSWORD_FAILURE',
};

export const userInviteActionType = {
    RESEND: 'resend',
    REVOKE: 'revoke',
    UNREVOKE: 'unrevoke',
}

export const userInviteStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    EXPIRED: 'EXPIRED',
    REVOKED: 'REVOKED',
}

export const currentPage = {
    CREATE_PASSWORD: 'create',
    UPDATE_PASSWORD: 'update',
}

export const storageKey = {
    PASSWORD_STATUS: 'passwordStatus'
}

export const description = {
    RESEND: 'Are you sure you want to resend this invitation? The user will receive a new email with the same invite details',
    REVOKE: 'Are you sure you want to revoke this invitation? The user will no longer be able to accept it',
    UNREVOKE: 'Are you sure you want to restore this invitation? If the invitation hasn’t expired, the user will be able to accept it again',
};